export default __webpack_public_path__ + "static/100--stacked-column-3faaedd3531900870c1c3c5fdccbe29a.png";